import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RestApiService } from '../rest-api.service';
import { INumberInputModel, INumberViewModel, ProjectWorkflowStatusInputModel, ProjectWorkflowStatusOutputModel } from 'src/app/ViewModel/ProjectWorkflowStatus';

@Injectable({
	providedIn: 'root'
})
export class ProjectWorkflowStatusService {

	private readonly getChecklistUrl = 'ProjectWorkflowStatus/getProjectWorkflowStatus';
	private readonly postWorkflowUrl = 'ProjectWorkflowStatus/PostProjectMembertDetails';
	private readonly getNumberDetails = 'ProjectWorkflowStatus/GetProjectNumbering';
	private readonly postNumberDetails = 'ProjectWorkflowStatus/PostProjectNumbering';
    public x !:number;
	public checklistId: BehaviorSubject<number> = new BehaviorSubject<number>(this.x);

	constructor(
		public restApiService: RestApiService,
	) { }


	getProjectWorkflowStatus(projectId: number,groupId: number): Observable<ProjectWorkflowStatusOutputModel[]> {
		let reqData = {
			project_Id:projectId,
			group_Id :groupId
		}
		return this.restApiService.new_POST(this.getChecklistUrl, reqData);
	}

	postProjectWorkflowStatus(Input:ProjectWorkflowStatusInputModel) {
		return this.restApiService.new_POST(this.postWorkflowUrl, Input);
	}

	getNumber(project_Id: number,group_Id: number, input_Type: string): Observable<INumberViewModel[]> {
		let reqData = {
			project_Id:project_Id,
			group_Id :group_Id,
			input_Type:input_Type
		}
		return this.restApiService.new_POST(this.getNumberDetails, reqData);
	}
	postNumber(Input:INumberInputModel){
		return this.restApiService.new_POST(this.postNumberDetails, Input);
	}

}
